<template>       
  <v-layout text-xs-center wrap>
   <v-flex xs12 mt-4>
      <v-img
        :src="require('@/assets/img/merk.jpg')"
        class="my-3"
        contain
        height="180"
      ></v-img>
    </v-flex>    
    <v-flex pa-4>            
      <h1 class="display-1 font-weight-bold mb-3">
        Pengumuman Hasil Seleksi
      </h1>      
      <div px-4 v-if="fm">        
        <template v-if="fm.lulus == 1">
          <v-alert :value="true" color="success" icon="how_to_reg">
            <span class="title" v-html="pengumumans.find(x=>x.name == fm.lulus) ? pengumumans.find(x=>x.name == fm.lulus).childs.replace('[nama]', fm.nama).replace('[no_ujian]', fm.calonGedung.number) : ''"></span>
            <template v-if="fm.tingkat_id == 3">
              <span  class="headline"> di <strong>MA</strong> </span>
              <template v-if="fm.lulus_jurusan == 4">
                <span class="headline">  jurusan <strong>IPA</strong></span>
              </template>
              <template v-if="fm.lulus_jurusan == 5">
                <span class="headline">  jurusan <strong>IPS</strong></span>
              </template>
              <template v-if="fm.lulus_jurusan == 6">
                <span class="headline">  jurusan <strong>AGAMA</strong></span>
              </template>
            </template>
          </v-alert>          
        </template>
        <template v-else-if="fm.lulus == 2">
          <v-alert :value="true" color="purple" icon="how_to_reg">
            <span class="headline">{{ pengumumans.find(x=>x.name == fm.lulus) ? pengumumans.find(x=>x.name == fm.lulus).childs.replace('[nama]', fm.nama).replace('[no_ujian]', fm.calonGedung.number) : '' }}</span>
            <template v-if="fm.tingkat_id == 3">
              <span  class="headline"> di <strong>MA</strong> </span>
              <template v-if="fm.jurusan_id == 4">
                <span  class="headline">  jurusan <strong>IPA</strong></span>
              </template>
              <template v-if="fm.jurusan_id == 5">
                <span  class="headline">  jurusan <strong>IPS</strong></span>
              </template>
              <template v-if="fm.jurusan_id == 6">
                <span  class="headline">  jurusan <strong>AGAMA</strong></span>
              </template>
            </template>           
          </v-alert>                    
        </template>
        <template  v-else-if="fm.lulus == -1">
          <v-alert :value="true" color="warning" icon="error">
            <span class="headline">{{ pengumumans.find(x=>x.name == fm.lulus) ? pengumumans.find(x=>x.name == fm.lulus).childs.replace('[nama]', fm.nama).replace('[no_ujian]', fm.calonGedung.number) : '' }}</span>            
          </v-alert>
        </template>  
        <template  v-else>
          <v-alert :value="true" color="info">
            <span class="headline">{{ pengumumans.find(x=>x.name == fm.lulus) ? pengumumans.find(x=>x.name == fm.lulus).childs.replace('[nama]', fm.nama).replace('[no_ujian]', fm.calonGedung.number) : '' }}</span>            
          </v-alert>
        </template>  


        <template  v-if="fm.tingkat_id>=3 && fm.lulus_jurusan && fm.lulus_jurusan!=fm.jurusan_id && (fm.lulus == -1 || fm.lulus == 2)">
          <v-alert :value="true" color="success" icon="how_to_reg">
            <span class="headline" v-html="pengumumans.find(x=>x.name == fm.lulus) ? pengumumans.find(x=>x.name == fm.lulus).childs.replace('[nama]', fm.nama).replace('[no_ujian]', fm.calonGedung.number) : ''"> dipilihan ke 2, </span>
            <template v-if="fm.tingkat_id == 3">
              <span  class="headline"> di <strong>MA</strong> </span>
              <template v-if="fm.lulus_jurusan == 4">
                <span class="headline">  jurusan <strong>IPA</strong></span>
              </template>
              <template v-if="fm.lulus_jurusan == 5">
                <span class="headline">  jurusan <strong>IPS</strong></span>
              </template>
              <template v-if="fm.lulus_jurusan == 6">
                <span class="headline">  jurusan <strong>AGAMA</strong></span>
              </template>            
            </template>
          </v-alert>                    
        </template>                  
      </div>
      <div v-else>
         <v-progress-circular
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </div>
       
      <p class="mt-4">
        Butuh bantuan, atau ingin berbagi informasi, silahkan chat kami dengan mengklik icon whatsapp di pojok kanan bawah          
        <br>atau kunjungi situs kami di 
        <a href="https://arrisalah.sch.id" target="_blank">https://arrisalah.sch.id</a>
      </p>   
    </v-flex>    
  </v-layout>      
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
const  model = new Model();

export default {
  name:'step7',  
  components: { 
  },
  data:()=>({    
    user : User.attributes(),
    pengumumans: [],
    fm: null
  }),
  mounted(){
    model.settings({key:'pengumuman'}).then(data=>{
      this.pengumumans = data.value
      model.viewAdministrasi({id:this.user.id}).then(data2=>{
        this.fm = data2     
      });            
    });    
  } 
};
</script>


